export const mapDateTime = (data, hora) => {
    return `${data}, ${hora}`
}